/* eslint-disable react/display-name */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */

import React, { memo } from 'react';
import { Flex, Text, Box } from '@chakra-ui/core';
import { EmptyPlaceholder } from '../components/TableComponents';
import { MismatchBadge } from '../components/MismatchBadge';

interface MinHoursCellProps {
  minHoursLabel?: string;
  isMismatch?: boolean;
}

export const MinHoursCell = memo(({ minHoursLabel, isMismatch }: MinHoursCellProps) => (
  <Box data-testid="min-hours-cell">
    {!minHoursLabel ? (
      <Box data-testid="min-hours-cell-empty">
        <EmptyPlaceholder />
      </Box>
    ) : (
      <>
        <Flex align="center" justify="space-between" width="100%">
          <Text fontSize="13px" color="inherit" display="inline-block" data-testid="min-hours-cell-label">
            {minHoursLabel}
          </Text>
          {isMismatch && <MismatchBadge data-testid="min-hours-cell-mismatch" />}
        </Flex>
      </>
    )}
  </Box>
));

MinHoursCell.displayName = 'MinHoursCell';
